import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Box, Typography, Container, CircularProgress } from '@mui/material';
import axios from 'axios';

const Unsubscribe = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const unsubscribe = async () => {
            const email = searchParams.get('email');
            const token = searchParams.get('token');

            if (!email || !token) {
                setStatus('error');
                setMessage('Invalid unsubscription link.');
                return;
            }

            try {
                const response = await axios.post('/api/auth/unsubscribe', { email, token });
                if (response.data.success) {
                    setStatus('success');
                } else {
                    setStatus('error');
                    setMessage(response.data.error || 'Failed to unsubscribe.');
                }
            } catch (err) {
                console.error('Unsubscribe error:', err);
                setStatus('error');
                setMessage('An error occurred. Please try again later.');
            }
        };

        unsubscribe();
    }, [searchParams]);

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '60vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    py: 8
                }}
            >
                {status === 'loading' && (
                    <CircularProgress color="inherit" size={24} />
                )}

                {status === 'success' && (
                    <>
                        <Typography
                            variant="h3"
                            sx={{
                                mb: 6,
                                fontWeight: 300,
                                letterSpacing: '2px',
                                fontSize: { xs: '32px', md: '48px' }
                            }}
                        >
                            <span style={{ fontFamily: '"Playfair Display", serif' }}>DAINA</span>{' '}
                            <span style={{ fontFamily: 'sans-serif', fontWeight: 300 }}>Collection</span>
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                mb: 1,
                                lineHeight: 1.6
                            }}
                        >
                            You've unsubscribed from our mailing list.
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                margin: '0 auto',
                                lineHeight: 1.6
                            }}
                        >
                            You won't receive any more marketing updates from us. You can subscribe again at any time.
                        </Typography>
                    </>
                )}

                {status === 'error' && (
                    <Typography variant="body1" color="error">
                        {message}
                    </Typography>
                )}
            </Box>
        </Container>
    );
};

export default Unsubscribe;
